import React from 'react';
import formatEpisodeDuration from './helpers/formatEpisodeDuration'
import shortenString from './helpers/shortenString'

export default function EpisodeList(props) {
	const eps = props.order === 'asc' ? props.episodes.reverse() : props.episodes;
	const classname = props.height === true ? 'episodesArea-height-large' : 'episodesArea';
	return (
		<div className={classname}>
			{
				eps.map(episode => {
					return (
						<div key={episode.guid} className='episode'>
							<img alt={episode.title} className='img-fluid episodeImg' src={episode.itunes.image} onClick={() => props.playEpisode(episode)}/>
							<div className='info' onClick={() => props.playEpisode(episode)}>
								<div className={props.activeEpisodeGuid === episode.guid ? 'text-orange title' : 'title'}>{shortenString(episode.title)}</div>
								<div className='dateduration'>{episode.pubDate.slice(4,16)} | {formatEpisodeDuration(episode.itunes.duration)}</div>
							</div>
							{ props.activeEpisodeGuid === episode.guid && props.playing ? <div className="pause" onClick={props.handlePause}></div> : <div className="play" onClick={() => props.playEpisode(episode)}></div>}
						</div>
					)
				})
			}
		</div>
	);
}